module.exports = "fragment AwardGroupFragment on AwardGroup {\n  name\n  imageUrl\n  awards {\n    ...AwardFragment\n  }\n}\n"